import DrinkPackageCreate from './DrinkPackageCreate'
import DrinkPackageEdit from './DrinkPackageEdit'
import { buildPackageList } from 'ui-shared/WrappedInputs/Packages/BasePackageList'

const drinkPackageIndex = {
  list: buildPackageList('drinks'),
  edit: DrinkPackageEdit,
  create: DrinkPackageCreate,
}

export default drinkPackageIndex
